import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VehicleImageModel, VehicleModel } from '../../../models/vehicle.model';
import { VehicleService } from '../../../services/vehicle.service';

@Component({
    selector: 'app-vehicle',
    templateUrl: './vehicle.component.html',
    encapsulation: ViewEncapsulation.None
})

export class VehicleComponent implements OnInit {
    idVehicle: number;
    vehicle: VehicleModel = new VehicleModel();
    vehicleImage: VehicleImageModel;
    vehicleImages: any[];
    mainImage: any;
    lblPageTitle: string;
    lblButtonText: string;
    showInputNewVehicleImage: boolean;

    constructor(
        private route: ActivatedRoute,
        private vehicleService: VehicleService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.idVehicle = parseInt(this.route.snapshot.params.idVehicle);
        this.vehicleImage = new VehicleImageModel();

        // Edição
        if (this.idVehicle) {
            this.getVehicleById(this.idVehicle);
            this.lblPageTitle = "Edição do veículo " + this.idVehicle;
            this.lblButtonText = "Editar veículo";
        }
        else {// Criação
            this.vehicle = new VehicleModel();
            this.lblPageTitle = "Criação de novo veículo";
            this.lblButtonText = "Criar veículo";
        }
    }

    getVehicleById(idVehicle: number) {
        this.vehicleService.getVehicleById(idVehicle).subscribe(data => {
            this.vehicle = data[0];
            this.vehicleImage.IdVehicle = this.vehicle.IdVehicle;

            this.vehicleService.getVehicleImagesByIdVehicle(idVehicle).subscribe(images => {
                this.vehicleImages = images;
            });
        });
    }

    toggleInputNewVehicleImage(): void {
        this.showInputNewVehicleImage = !this.showInputNewVehicleImage;
    }

    saveVehicle(): void {
        this.vehicleService.saveVehicle(this.vehicle).subscribe(res => {
            Swal.fire({
                icon: 'success',
                confirmButtonColor: '#00C853',
                text: res.toString()
            });
            this.router.navigate(['/admin/home']);
        }, err => {
            Swal.fire({
                icon: 'error',
                cancelButtonColor: '#aaa',
                text: err.toString()
            }), err
        });
    }

    saveVehicleImage(): void {
        this.vehicleService.saveVehicleImage(this.vehicleImage).subscribe(res => {
            this.showInputNewVehicleImage = false;
            this.vehicleImage = new VehicleImageModel();
            this.vehicleImage.IdVehicle = this.vehicle.IdVehicle;

            this.vehicleService.getVehicleImagesByIdVehicle(this.idVehicle).subscribe(images => {
                this.vehicleImages = images;
            });

            Swal.fire({
                icon: 'success',
                confirmButtonColor: '#00C853',
                text: res.toString()
            });

        }, err => {
            this.showInputNewVehicleImage = false;
            this.vehicleImage = new VehicleImageModel();
            this.vehicleImage.IdVehicle = this.vehicle.IdVehicle;

            this.vehicleService.getVehicleImagesByIdVehicle(this.idVehicle).subscribe(images => {
                this.vehicleImages = images;
            });

            Swal.fire({
                icon: 'error',
                cancelButtonColor: '#aaa',
                text: err.toString()
            }), err
        });
    }

    deleteVehicleImage(idVehicleImage: number): void {
        Swal.fire({
            title: 'Deseja remover a imagem?',
            text: 'Essa ação não poderá ser desfeita',
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#F44336',
            cancelButtonColor: '#aaa',
            confirmButtonText: 'Sim, remover a imagem'
        }).then((result) => {
            if (result.isConfirmed) {
                this.vehicleService.deleteVehicleImage(idVehicleImage).subscribe(res => {
                    this.showInputNewVehicleImage = false;
                    this.vehicleService.getVehicleImagesByIdVehicle(this.idVehicle).subscribe(images => {
                        this.vehicleImages = images;
                    });

                    Swal.fire({
                        icon: 'success',
                        confirmButtonColor: '#00C853',
                        text: res.toString()
                    });

                }, err => {
                    Swal.fire({
                        icon: 'error',
                        cancelButtonColor: '#aaa',
                        text: err.toString()
                    }), err
                });
            }
        })
    }

    deleteFeatureImage(): void {
        Swal.fire({
            title: "Essa é a imagem principal",
            html: "Para editá-la favor editar o<br />campo <b>IMAGEM PRINCIPAL</b> acima.",
            icon: 'info',
            confirmButtonColor: '#aaa',
        });
    }
}

// VehicleImageModel não está inicializado